// extracted by mini-css-extract-plugin
export default {"image":"QW-z","loaded":"RW-z"};